export default "__VITE_ASSET__D3iBmZ0C__ 640w, __VITE_ASSET__Dj5PJwDt__ 1024w, __VITE_ASSET__BidVGEo___ 1536w";